<template>
  <EntityListItem
    icon="file"
    icon-tone="sky"
    :title="title"
    clickable
    @click="handleClick"
  >
    <template #subtitle>
      <span v-if="customerName">{{ customerName }}</span>
      <span v-if="ageText">· {{ ageText }}</span>
    </template>

    <template #right>
      <span v-if="proposal.total_amount != null" class="proposal-list-item__amount">
        {{ formatCurrency(proposal.total_amount) }}
      </span>
      <ProposalStatusBadge
        v-if="proposal.status"
        :status="proposal.status"
        size="sm"
      />
    </template>
  </EntityListItem>
</template>

<script>
  import { computed, getCurrentInstance } from 'vue';
  import { useRouter } from 'vue-router';
  import dayjs from 'dayjs';
  import EntityListItem from '@/components/partials/lists/EntityListItem.vue';
  import ProposalStatusBadge from '@/components/partials/ProposalStatusBadge.vue';
  import { formatCurrency } from '@/utils/currency';

  export default {
    name: 'ProposalListItem',

    components: { EntityListItem, ProposalStatusBadge },

    props: {
      proposal: { type: Object, required: true },
    },

    emits: ['click'],

    setup(props, { emit }) {
      const instance = getCurrentInstance();
      const $t = instance.appContext.config.globalProperties.$t;
      const router = useRouter();

      const title = computed(() => {
        const num = props.proposal.proposal_number || props.proposal.number;
        if (props.proposal.title) return props.proposal.title;
        if (num) return `${$t('proposals.number')} ${num}`;
        return $t('home.proposals.untitled');
      });

      const customerName = computed(
        () =>
          props.proposal.customer_name ||
          props.proposal.lead?.name ||
          props.proposal.deal?.lead?.name ||
          ''
      );

      const ageText = computed(() => {
        const sentDate = props.proposal.sent_at || props.proposal.created_at;
        if (!sentDate) return '';
        const days = dayjs().diff(dayjs(sentDate), 'day');
        if (days === 0) return $t('home.today');
        if (days === 1) return $t('home.days_ago', { n: 1 });
        return $t('home.days_ago', { n: days });
      });

      const handleClick = () => {
        emit('click', props.proposal);
        if (props.proposal.id) {
          router.push(`/proposals/${props.proposal.id}`);
        }
      };

      return { title, customerName, ageText, formatCurrency, handleClick };
    },
  };
</script>

<style scoped lang="scss">
  .proposal-list-item {
    &__amount {
      font-weight: 600;
      font-size: 0.875rem;
      color: var(--slate-900);
      font-variant-numeric: tabular-nums;
    }
  }
</style>
